export enum PropertyConstants {
  Container = 'Experiment.Default.Container',
  ConcentrationUnits = 'IngredientStock.ConcentrationUnits',
  StocksDefaultLiquidClass = 'IngredientStock.Default.LiquidClass',
  StocksDefaultDispenseOrder = 'IngredientStock.Default.DispenseOrder',
  ScreenExperimentWizardNameDelimiter = 'ScreenExperimentWizard.NameDelimiter',
  ScreenExperimentWizardDateTimeFormat = 'ScreenExperimentWizard.DateTimeFormat',
  ScoreWithoutImages = 'Scores.Score.ScoreWithoutImages',
  AllowEditingOfReadonlyExperiment = 'Experiment.AllowEditingOfReadonlyExperiment',
  ExplorerSidePanelOpen = 'Experiment.Default.ExplorerSidePanelOpen',
  SeachFilterEnableCanvas = 'SearchFilter.EnableCanvas',
  DefaultCrystalName = 'Project.Default.CrystalName',
  ShowIngredientLongName = 'Ingredient.ShowLongName',
  AllowDisputedScoreDrawing = 'Scores.AllowDisputedScoreDrawing',
  ExperimentNavigatorVisible = 'Experiment.Navigator.ExperimentNavigator.Visible',
  SlideShowChangeInterval = 'SlideShow.SlideChangeInterval',
  RestartScoringOnceDone = 'Imaging.PlateViewer.RestartScoringOnceDone',
  DropImageVerticalPrefetchingCount = 'Drop.Imaging.Prefetching.Vertical',
  DropImageHorizontalPrefetchingCount = 'Drop.Imaging.Prefetching.Horizontal',
  CanvasNavigatorPrefetchingVertical = 'Canvas.Navigator.Prefetching.Vertical',
  CanvasNavigatorPrefetchingHorizontal = 'Canvas.Navigator.Prefetching.Horizontal',
}
